// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"RefundModal_errorMessage__2eRc0","footerContainer":"RefundModal_footerContainer__2Wrpl"};